import { gql } from '@apollo/client';

/**
 * Spec 0012 (homework submissions) — the shared submission selection reused by
 * every ERP homework query (lesson roster drill-down + student history). The
 * nested `aiReview` is the staff-only verdict; both are read-only in ERP.
 */
export const HOMEWORK_SUBMISSION_FIELDS = gql`
  fragment HomeworkSubmissionFields on HomeworkSubmissionType {
    id
    githubUrl
    fileName
    fileSizeBytes
    status
    attempt
    submittedAt
    teacherComment
    gradedAt
    gradedByName
    aiReview {
      status
      aiScore
      aiSummary
      aiJustification
      suspiciousContent
      suspicionNotes
      errorMessage
      analyzedAt
    }
  }
`;
